import { useEffect } from 'preact/hooks';
import {
  descriptionActions,
  useEpisodeDescription,
} from '../global-state/episode-descriptions';
import { Episode } from '../models/podcasts';

export function EpisodeDescription({ episode }: { episode: Episode }) {
  // Fetch episode description from IndexedDB / API and stick it in memory
  useEffect(() => {
    descriptionActions.fetchEpisodeDescription(episode);
  }, [episode.id]);

  const description = useEpisodeDescription(episode);
  if (description)
    return (
      <div
        class="mt-4 [&_a]:text-blue-500 [&_a]:underline"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    );

  // Loading state
  return (
    <>
      <p class="mt-4 whitespace-pre-wrap">{episode.excerpt}</p>
      <p class="p-10 text-center">
        <em>Loading full description...</em>
      </p>
    </>
  );
}
